import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import parseJSON from 'common/util/parseJSON';

import { USER_ROLE_ADMIN } from 'common/userRoles';
import { SR_API_ACTION_ADMIN_SEND_PUSH_NOTIFICATION } from 'api/actionTypes';
import { SCREEN_ID_ADMIN_TEST_PUSH_NOTIFICATION } from 'client/constants/screenIds';

import Navbar from 'client/components/Navbar';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import H1 from 'client/components/H1';
import SrFormikField from 'client/components/SrFormikField';

import branch from 'client/core/branch';
import withApiState from 'client/helpers/withApiState';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withTransitionHook from 'client/helpers/withTransitionHook';
import allowedRoles from 'client/helpers/allowedRoles';
import { createFormValidationFn, createInitialValues } from 'client/helpers/formikHelpers';
import postWithState from 'client/actions/postWithState';

const formFields = [
  {
    id: 'userPhone',
    title: 'user phone',
    type: 'phone',
    properties: {
      placeholder: '5121234567',
    },
    validations: ['required', 'phone'],
  },
  {
    id: 'notificationTitle',
    title: 'title',
    type: 'short_text',
    validations: ['required'],
  },
  {
    id: 'notificationBody',
    title: 'body',
    type: 'long_text',
    validations: ['required'],
  },
  {
    id: 'data',
    title: 'data',
    type: 'long_text',
    properties: {
      placeholder:
        '{\n' +
        ' "notificationType": "SR_PUSH_NOTIFICATION_ACTION_GO_TO_PAGE",\n' +
        ' "pageUrl": "/feed"\n' +
        '}',
    },
    validations: ['json'],
  },
];

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withApiState({
  sendPushNotificationApiState: {
    action: SR_API_ACTION_ADMIN_SEND_PUSH_NOTIFICATION,
  },
})
@withScrollToTop
@withScreenId(SCREEN_ID_ADMIN_TEST_PUSH_NOTIFICATION)
@branch()
class AdminTestPushNotification extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    sendPushNotificationApiState: PropTypes.object.isRequired,
  };

  _sendPushNotification = (values) => {
    const { dispatch } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_SEND_PUSH_NOTIFICATION,
      payload: {
        ...values,
        data: values.data ? parseJSON(values.data) : null,
      },
    });
  };

  render() {
    const { sendPushNotificationApiState } = this.props;
    const formInitialState = createInitialValues({ formFields, defaultValues: {} });

    return (
      <div className="page-admin">
        <div className="adminContainer">
          <Navbar redirectLogoTo="/admin" />

          <div className="contentContainer">
            <Formik
              validateOnChange
              initialValues={formInitialState}
              validate={createFormValidationFn(formFields)}
              onSubmit={this._sendPushNotification}
              render={(formikBag) => {
                return (
                  <div>
                    <div className="header">
                      <H1>Write push notification</H1>
                    </div>
                    <Form className="pushNotificationForm">
                      {formFields.map((formField) => (
                        <SrFormikField
                          key={formField.id}
                          formField={formField}
                          formikBag={formikBag}
                        />
                      ))}
                      <div className="bottomActions">
                        <ButtonDeprecated
                          onClick={formikBag.handleSubmit}
                          disabled={!formikBag.isValid || sendPushNotificationApiState.inProgress}
                        >
                          {sendPushNotificationApiState.inProgress ? 'Sending ...' : 'Send'}
                        </ButtonDeprecated>
                      </div>
                    </Form>
                  </div>
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

AdminTestPushNotification.displayName = 'AdminTestPushNotification';

export default AdminTestPushNotification;
